import { useDelayedExperiment } from '@growtherapy/analytics/client';

import {
  INTAKE_SUMMARY_LAYER_PARAM,
  PROVIDER_INTAKE_REVIEW_LAYER,
  PROVIDER_INTAKE_SUMMARY_DELAYED_EXPERIMENT_CONFIG,
  PROVIDER_INTAKE_SUMMARY_EXPERIMENT,
} from '../../statsig/delayedExperiments';
import { useIntakeSummaryExperimentTracking } from './useIntakeSummaryExperimentTracking';

/**
 * Orchestrates the intake summary delayed experiment in telehealth.
 * Allocation and experience are shared with the portal; launch banner UI is not.
 */
export function useIntakeSummaryDelayedExperiment(providerShortId: string) {
  const { recordExperimentAllocation, onStageTransition } = useIntakeSummaryExperimentTracking(providerShortId);

  return useDelayedExperiment({
    experimentKey: PROVIDER_INTAKE_SUMMARY_EXPERIMENT,
    layer: PROVIDER_INTAKE_REVIEW_LAYER,
    layerParamKey: INTAKE_SUMMARY_LAYER_PARAM,
    isTreatment: (value) => value === 'true',
    dynamicConfigKey: PROVIDER_INTAKE_SUMMARY_DELAYED_EXPERIMENT_CONFIG,
    recordExperimentAllocation,
    onStageTransition,
  });
}
